import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;
import TAOS from "./../Taos";
import { ChevronIcon2 } from './SVGIcons';

class App extends Component {
  
  // Функция для выбора иконки по номеру
  renderIcon(iconNumber) {
    switch(iconNumber) {
      case '1':
        return (
          <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.70117 9.25977L12.0012 12.3298L17.2612 9.27976" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.002 17.7698V12.3198" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.7603 6.28986L7.56024 8.06986C6.84024 8.46986 6.24023 9.47985 6.24023 10.3099V13.6999C6.24023 14.5299 6.83024 15.5399 7.56024 15.9399L10.7603 17.7199C11.4403 18.0999 12.5602 18.0999 13.2502 17.7199L16.4503 15.9399C17.1703 15.5399 17.7702 14.5299 17.7702 13.6999V10.2999C17.7702 9.46986 17.1803 8.45985 16.4503 8.05985L13.2502 6.27985C12.5602 5.89985 11.4403 5.89986 10.7603 6.28986Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22 15C22 18.87 18.87 22 15 22L16.05 20.25" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2 9C2 5.13 5.13 2 9 2L7.95001 3.75" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        );
      case '2':
        return (
          <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.9998 14H12.9998C14.0998 14 14.9998 13.1 14.9998 12V2H5.99976C4.49976 2 3.18977 2.82999 2.50977 4.04999" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2 17C2 18.66 3.34 20 5 20H6C6 18.9 6.9 18 8 18C9.1 18 10 18.9 10 20H14C14 18.9 14.9 18 16 18C17.1 18 18 18.9 18 20H19C20.66 20 22 18.66 22 17V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L18.58 6.01001C18.22 5.39001 17.56 5 16.84 5H15V12C15 13.1 14.1 14 13 14H12" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22 12V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L22 12Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2 8H8" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2 11H6" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2 14H4" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        );
      case '3':
        return (
          <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.9 22H7.10001C5.40001 22 4 20.61 4 18.9V5.10001C4 3.40001 5.39001 2 7.10001 2H16.9C18.6 2 20 3.39001 20 5.10001V18.9C20 20.61 18.61 22 16.9 22Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18.5 13H5.5C4.67 13 4 12.33 4 11.5V9.5C4 8.67 4.67 8 5.5 8H18.5C19.33 8 20 8.67 20 9.5V11.5C20 12.33 19.33 13 18.5 13Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.49451 17.7002H8.50349" stroke="#009EE3" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.4945 17.7002H15.5035" stroke="#009EE3" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.5 5H14.5" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        );
      case '4':
        return (
          <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.16992 7.43994L11.9999 12.5499L20.7699 7.46991" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 21.61V12.54" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.9306 2.48L4.59061 5.45003C3.38061 6.12003 2.39062 7.80001 2.39062 9.18001V14.83C2.39062 16.21 3.38061 17.89 4.59061 18.56L9.9306 21.53C11.0706 22.16 12.9406 22.16 14.0806 21.53L19.4206 18.56C20.6306 17.89 21.6206 16.21 21.6206 14.83V9.18001C21.6206 7.80001 20.6306 6.12003 19.4206 5.45003L14.0806 2.48C12.9306 1.84 11.0706 1.84 9.9306 2.48Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.9998 13.2401V9.58014L7.50977 4.1001" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        );
      case '5':
        return (
          <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 2V12C15 13.1 14.1 14 13 14H2V6C2 3.79 3.79 2 6 2H15Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22 14V17C22 18.66 20.66 20 19 20H18C18 18.9 17.1 18 16 18C14.9 18 14 18.9 14 20H10C10 18.9 9.1 18 8 18C6.9 18 6 18.9 6 20H5C3.34 20 2 18.66 2 17V14H13C14.1 14 15 13.1 15 12V5H16.84C17.56 5 18.22 5.39001 18.58 6.01001L20.29 9H19C18.45 9 18 9.45 18 10V13C18 13.55 18.45 14 19 14H22Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22 12V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L22 12Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        );
      default:
        return null;
    }
  }

  // Функция для рендера карточки в зависимости от типа v
  renderCard(card, index, isLastInRow) {
    const { v, icon, images, name, name2, text } = card;
    const data = this.props?.data || {};
    const delivery = data?.delivery || {};
    const last_bg = delivery?.last_bg || 'src/images/trusr_card4_bg.png';
    const slogo = data?.slogo || 'src/images/trusr_logo.png';
    const { showWindow } = this.props

    // Карточка типа 2 (специальная с фоном)
    if (v === '2') {
      return (
        <TAOS
          as="div"
          key={index}
          className={`
            flex-1 xl:min-h-[221px] rounded-[15px] p-[20px]
            duration-[300ms] taos:[transform:perspective(2500px)_rotateY(-100deg)] taos:invisible taos:[backface-visibility:hidden]
            w-full xl:w-auto
          `}
          style={{
            backgroundColor: `#009EE3`,
            backgroundImage: `url("${last_bg}")`,
            backgroundSize: 'cover'
          }}
          offset="300"
        >
          <div className='flex justify-between items-start'>
            <h3 className='font-medium text-[24px] xl:text-[36px] text-white leading-none'>
              <span dangerouslySetInnerHTML={{ __html: name }} />
              {name2 && <span className='text-white/60' dangerouslySetInnerHTML={{ __html: name2 }} />}
            </h3>
            <img className='hidden xl:block' src={slogo} width={50} height={50} alt='logo' />
          </div>
          <div className='flex justify-between items-center mt-[10px] xl:mt-[30px] gap-[26px]'>
            <div className='text-white/60 text-[14px] xl:text-[16px] tracking-[-0.02em]'>{Parser(text)}</div>
            <div onClick={() => showWindow()} className='hidden xl:flex items-center gap-[9px] h-[50px] px-[19px] bg-white text-black rounded-full cursor-pointer whitespace-nowrap'>
              <div>Связаться с менеджером</div>
              <ChevronIcon2 stroke="black" />
            </div>
          </div>
          <div className='flex xl:hidden items-center gap-[10px] mt-[20px]'>
            <div onClick={() => showWindow()} className='flex flex-1 items-center gap-[9px] h-[38px] justify-center text-[12px] bg-white text-black rounded-full cursor-pointer whitespace-nowrap'>
              <div>Связаться с менеджером</div>
              <ChevronIcon2 stroke="black" />
            </div>
            <img className='flex-none' src={slogo} width={38} height={38} alt='logo' />
          </div>
        </TAOS>
      );
    }

    // Определяем ширину карточки в зависимости от позиции
    let widthClass = '';
    if (index === 0) widthClass = 'xl:w-[286px]';
    else if (index === 1) widthClass = 'xl:w-[287px]';
    else if (index === 2) widthClass = 'xl:w-[286px]';
    else if (index === 3) widthClass = 'flex-1 xl:w-auto';
    else if (index === 4) widthClass = 'xl:w-[286px]';

    return (
      <TAOS
        as="div"
        key={index}
        className={`
          w-full ${widthClass} xl:min-h-[221px] rounded-[15px] bg-[#F5F7F9] p-[20px] pr-[10px]
          duration-[300ms] taos:[transform:perspective(2500px)_rotateY(-100deg)] taos:invisible taos:[backface-visibility:hidden]
        `}
        offset="300"
      >
        <div className='flex flex-row-reverse xl:flex-col justify-between items-start w-full'>

          {/* Если есть images, показываем иконку слева и изображения справа */}
          {images && Array.isArray(images) && images.length > 0 ? (
            <div className='flex justify-between items-center gap-[5px] xl:w-full'>
              <div className='flex items-center'>
                {icon && this.renderIcon(icon)}
              </div>
              <div className='hidden xl:flex items-center gap-[5px]'>
                {images.map((img, idx) => (
                  <img key={idx} src={img} alt={`img-${idx+1}`} width={30} height={30} className='h-auto flex-none' />
                ))}
              </div>
            </div>
          ) : (
            // Если images нет, показываем только иконку
            icon && this.renderIcon(icon)
          )}

          <div className={images && Array.isArray(images) && images.length > 0 ? 'xl:mt-[24px]' : 'xl:mt-[31px]'}>
            <div className='text-[16px] xl:text-[18px] text-[#032432]'>
              <span dangerouslySetInnerHTML={{ __html: name }} />
              {name2 && <span className='text-[#032432]/60' dangerouslySetInnerHTML={{ __html: name2 }} />}
            </div>
          </div>

        </div>

        <div className='text-black/60 mt-[10px] text-[14px] xl:text-[16px] tracking-[-0.02em]'>{Parser(text)}</div>

        {images && Array.isArray(images) && images.length > 0 && (
          <div className='flex xl:hidden items-center justify-between gap-[5px] mt-[20px]'>
            {images.map((img, idx) => (
              <img key={idx} src={img} alt={`img-${idx+1}`} width={46} height={46} className='h-auto flex-none' />
            ))}
          </div>
        )}
      </TAOS>
    );
  }

  render() {
    const data = this.props?.data || {};
    const delivery = data?.delivery || {};

    if (!delivery || !delivery.items) {
      return null;
    }

    // Разделяем карточки на две строки
    const firstRowCards = delivery.items.slice(0, 4);
    const secondRowCards = delivery.items.slice(4, 6);

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        <div className='container'>
          <div className='flex justify-center xl:justify-start items-center gap-[10px] text-[14px] xl:text-[16px]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.25 1.5V9C11.25 9.825 10.575 10.5 9.75 10.5H1.5V4.5C1.5 2.8425 2.8425 1.5 4.5 1.5H11.25Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16.5 10.5V12.75C16.5 13.995 15.495 15 14.25 15H13.5C13.5 14.175 12.825 13.5 12 13.5C11.175 13.5 10.5 14.175 10.5 15H7.5C7.5 14.175 6.825 13.5 6 13.5C5.175 13.5 4.5 14.175 4.5 15H3.75C2.505 15 1.5 13.995 1.5 12.75V10.5H9.75C10.575 10.5 11.25 9.825 11.25 9V3.75H12.63C13.17 3.75 13.665 4.04251 13.935 4.50751L15.2175 6.75H14.25C13.8375 6.75 13.5 7.0875 13.5 7.5V9.75C13.5 10.1625 13.8375 10.5 14.25 10.5H16.5Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 16.5C6.82843 16.5 7.5 15.8284 7.5 15C7.5 14.1716 6.82843 13.5 6 13.5C5.17157 13.5 4.5 14.1716 4.5 15C4.5 15.8284 5.17157 16.5 6 16.5Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 16.5C12.8284 16.5 13.5 15.8284 13.5 15C13.5 14.1716 12.8284 13.5 12 13.5C11.1716 13.5 10.5 14.1716 10.5 15C10.5 15.8284 11.1716 16.5 12 16.5Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16.5 9V10.5H14.25C13.8375 10.5 13.5 10.1625 13.5 9.75V7.5C13.5 7.0875 13.8375 6.75 14.25 6.75H15.2175L16.5 9Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60'>Доставка</div>
            </div>
          </div>
          
          <h2 className='font-medium mt-[20px] xl:mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(delivery?.title)}</h2>
          <div className='mt-[10px] text-[14px] xl:text-[16px] tracking-[-0.02em] text-center xl:text-start text-black/60'>{Parser(delivery?.text)}</div>
          
          {/* Первая строка карточек */}
          <div className='flex flex-col xl:flex-row items-start gap-[10px] mt-[30px]'>
            {firstRowCards.map((card, index) => this.renderCard(card, index))}
          </div>
          
          {/* Вторая строка карточек */}
          {secondRowCards.length > 0 && (
            <div className='flex flex-col xl:flex-row items-start gap-[10px] mt-[10px]'>
              {secondRowCards.map((card, index) => this.renderCard(card, index + 4))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default App;